<ion-app>

  @if (isAuthenticated && !isOnNoShowPage && !isOnStandalonePage) {
    <ion-header class="desktop-header">
      <ion-toolbar [class]="menuToolbarColor ? 'custom-gradient-toolbar' : ''" [ngStyle]="menuToolbarStyle">
        @if (!isCollapsed) {
          <ion-button (click)="setSideMenuCollapsed(true)" color="light" fill="clear"
            size="small">
            <ion-icon name="ellipsis-vertical-sharp" slot="icon-only"></ion-icon>
          </ion-button>
        }
        @if (isCollapsed) {
          <ion-button (click)="setSideMenuCollapsed(false)" color="light" fill="clear"
            size="small">
            <ion-icon name="list-sharp" slot="icon-only"></ion-icon>
          </ion-button>
        }
      </ion-toolbar>
    </ion-header>
  }

  <ion-split-pane contentId="main">
    <ion-menu [class]="isCollapsed ? 'collapsed' : 'expanded'" [style]="isAuthenticated && !isOnNoShowPage && !isOnStandalonePage ? '' : 'display: none'"
      contentId="main"
      menuId="m1" side="start">
      <ion-header class="mobile-header">
        <ion-toolbar [color]="menuToolbarColor" [ngStyle]="menuToolbarStyle">
          <ion-title>
          </ion-title>
        </ion-toolbar>

      </ion-header>
      <ion-content class="side-menu-content">
        @if (shouldShowShowSwitcher()) {
          <ion-item
            (click)="openShowSwitcher()"
            [class.collapsed]="isCollapsed"
            [class.expanded]="!isCollapsed"
            button
            class="show-switcher"
            detail="false"
            lines="full"
            >
            <div class="show-switcher-row">
              <app-show-avatar
                [imageUrl]="authState.activeShowImageUrl"
                [showName]="authState.activeShowName || ''"
                size="small">
              </app-show-avatar>
              <div [class.collapsed]="isCollapsed" [class.expanded]="!isCollapsed" class="show-switcher-label">
                <div class="show-switcher-hint">Actieve productie</div>
                <div class="show-switcher-name">{{ authState.activeShowName || 'Kies een show' }}</div>
              </div>
              <ion-icon
                [class.collapsed]="isCollapsed"
                [class.expanded]="!isCollapsed"
                class="show-switcher-swap"
                name="swap-horizontal-outline"
              ></ion-icon>
            </div>
          </ion-item>
        }

        @if (shouldShowShowSwitcher()) {
          <ion-item-divider mode="ios">
            <ion-label [class]="isCollapsed ? 'collapsed' : 'expanded'" class="divider-label">
              Menu
            </ion-label>
          </ion-item-divider>
        }

        <ion-list class="ion-no-padding menu-list" lines="none">
          @for (item of menuItems; track item; let i = $index) {
            @if (item.isDivider && sectionVisibility.get(i)) {
              <ion-item-divider mode="ios">
                <ion-label [class]="isCollapsed ? 'collapsed' : 'expanded'"
                  class="divider-label">{{ item.label }}
                </ion-label>
              </ion-item-divider>
            }
            @if (!item.isDivider) {
              @if ((!item?.requiredPrivilege || authState.user()?.hasPrivilege(item.requiredPrivilege)) && (!item?.requiresShowFlag || authState.activeShow()?.[item.requiresShowFlag] === true)) {
                <ion-menu-toggle
                  autoHide="false"
                  menu="m1"
                  >
                  <ion-item
                    [color]="getActiveMenuItemColor(item.matchPrefix ? currentRoute.startsWith(item.route) : currentRoute === item.route)"
                    [ngStyle]="getActiveMenuItemStyle(item.matchPrefix ? currentRoute.startsWith(item.route) : currentRoute === item.route)"
                    [routerDirection]="'root'"
                    [routerLink]="item.route"
                    >
                    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between">
                      @if (!item.isCustomIcon) {
                        <ion-icon
                          [name]="item.icon"
                          slot="start"
                        ></ion-icon>
                      }
                      @if (item.isCustomIcon) {
                        <ion-icon
                          [src]="item.icon"
                          slot="start"
                        ></ion-icon>
                      }
                    </div>
                    <ion-label [class]="isCollapsed ? 'collapsed' : 'expanded'"
                      class="menu-label">{{ item.label }}
                    </ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }
            }
          }

          <ion-menu-toggle autoHide="false" menu="m1">
            <ion-item (click)="onLogout()" button>
              <div>
                <ion-icon name="exit-outline" slot="start" style="margin-right: 0"></ion-icon>
              </div>
              <ion-label [class]="isCollapsed ? 'collapsed' : 'expanded'" class="menu-label">
                Logout
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-item
            (click)="showDeviceInfo()" [class]="isCollapsed ? 'collapsed' : 'expanded'"
            class="menu-label"
            class="version-number"
            style="cursor: default; user-select: none;"
            >
            <ion-label [class]="isCollapsed ? 'collapsed' : 'expanded'" class="menu-label">
              Versie {{ getAppVersion() }}
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main" />

  </ion-split-pane>
  <app-no-network-connection-message />

</ion-app>
